$shm_hitalama_map_command_palette $shm_hitalama_command_palette
	auto /
		^
		<= benchmark_collect_notification null
